import {
  ITaskTimeline,
  Roles,
  TaskTimeLineType,
} from "@evennt-tech/api-v2-core";
import { UseTranslateResult } from "@tolgee/react";

type TranslateFn = UseTranslateResult["t"];

const composeActionName = ({ type, role }: ITaskTimeline, t: TranslateFn) => {
  switch (type) {
    case TaskTimeLineType.UPDATE_TASK_RESPONSES:
      return t("common.tasks.timeline.updated_response");
    case TaskTimeLineType.APPROVE:
      return t("common.tasks.timeline.approved");
    case TaskTimeLineType.EDIT_TASK_DESCRIPTION:
      return t("common.tasks.timeline.updated_task_description");
    case TaskTimeLineType.REJECT:
      return t("common.tasks.timeline.rejected_with_comment");
    case TaskTimeLineType.MOVE_TO_IN_REVIEW:
      return t("common.tasks.timeline.moved_to_in_review");
    case TaskTimeLineType.MOVE_TO_TODO:
      return t("common.tasks.timeline.moved_to_todo");
    case TaskTimeLineType.MOVE_TO_WAITING_FOR_APPROVAL:
      // Exhibitors can't move a task between statuses — an exhibitor row of
      // this type is a submit migrated from the legacy Firestore history.
      return role === Roles.EXHIBITOR
        ? t("common.tasks.timeline.submitted_for_approval")
        : t(
            "common.tasks.timeline.moved_to_waiting_for_approval",
            "Moved to Waiting for Approval"
          );
    case TaskTimeLineType.UPDATE_SUB_TASK_RESPONSE:
      return t("common.tasks.timeline.updated_subtask_response");
    case TaskTimeLineType.REMOVE_RESPONSE_FILE:
      return t("common.tasks.timeline.removed_file", "Removed file");
    case TaskTimeLineType.REMOVE_SUB_TASK_RESPONSE_FILE:
      return t(
        "common.tasks.timeline.removed_file_from_subtask",
        "Removed file from sub-task"
      );
    case TaskTimeLineType.REVISE:
      return t("common.tasks.timeline.moved_to_revision");
    default:
      return t("common.tasks.timeline.na");
  }
};

export default composeActionName;
